module.exports = __webpack_public_path__ + "img/remove-circle.3f10d15c.svg";